import * as React from 'react'
import { useListFavoriteToolsQuery } from '../../../gen/service/creativefabrica/studiomediamatrix/v1'
import type { ToolType } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1'
import type { ListFavoriteToolsResponse } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1/service'
import {
  ListFavoriteToolsResponseSchema,
  ListFavoriteToolsResponse_FavoritedToolSchema,
} from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1/service'
import { create } from '@bufbuild/protobuf'
import { loadFavoritesFromStorage, saveFavoritesToStorage } from '../utils/favorite-tools-storage'
import ms from 'ms'

export function useFavoriteToolTypes() {
  const { data: favoritesData } = useListFavoriteToolsQuery(
    {},
    {
      initialData: (): ListFavoriteToolsResponse => {
        const favorites = loadFavoritesFromStorage()

        return create(ListFavoriteToolsResponseSchema, {
          favorites: [...favorites].map(tool =>
            create(ListFavoriteToolsResponse_FavoritedToolSchema, { tool }),
          ),
        })
      },
      staleTime: ms('10 min'),
      refetchOnMount: false,
    },
  )

  React.useEffect(() => {
    if (!favoritesData) {
      return
    }

    // oxlint-disable-next-line unicorn/no-useless-collection-argument
    const tools = new Set(favoritesData.favorites?.map(f => f.tool) ?? [])
    saveFavoritesToStorage(tools)
  }, [favoritesData])

  const favoriteToolTypes = React.useMemo(() => {
    if (!favoritesData) {
      return new Set<ToolType>()
    }
    const allFavorites: ToolType[] = []
    favoritesData.favorites?.forEach(fav => {
      if (fav.tool) {
        allFavorites.push(fav.tool)
      }
    })
    return new Set(allFavorites)
  }, [favoritesData])

  return { favoriteToolTypes }
}
